import useMediaQuery from "./useMediaQuery";

/**
 * Helpers de breakpoints — alignés sur `_breakpoints.scss`.
 *
 *   mobile   : ≤ 599px
 *   tablet   : 600 → 1023px
 *   desktop  : ≥ 1024px
 *
 * Usage :
 *   const isMobile     = useIsMobile();
 *   const isTabletDown = useIsTabletDown();
 */
export const useIsMobile = () => useMediaQuery("(max-width: 599px)");
export const useIsTabletDown = () => useMediaQuery("(max-width: 1023px)");
export const useIsTabletOnly = () =>
  useMediaQuery("(min-width: 600px) and (max-width: 1023px)");
export const useIsDesktopUp = () => useMediaQuery("(min-width: 1024px)");
